module.exports = __webpack_public_path__ + "static/img/baise.141795b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baise.png
// module id = ULYo
// module chunks = 15